export function byPriority<T extends { priority: number }>(a: T, b: T): number {
  return a.priority - b.priority
}
